import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import PerhitunganRepository from '../Repositories/PerhitunganRepository'

class PerhitunganBloc
{
    repository = new PerhitunganRepository()
    perhitunganListChannel = new Subject()
    perhitunganSubmitChannel = new Subject()

    constructor() {
        this.perhitunganListChannel.next({status: apiResponse.INITIAL})
        this.perhitunganSubmitChannel.next({status: apiResponse.INITIAL})
    }

    fetchList = async (query) => {
        this.perhitunganListChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchList(query).then((result) => {
            this.perhitunganListChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.perhitunganListChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchSubmit = async (query) => {
        this.perhitunganSubmitChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSubmit(query).then((result) => {
            this.perhitunganSubmitChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.perhitunganSubmitChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

}

export default PerhitunganBloc